"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Container = function (_a) {
    var children = _a.children, className = _a.className;
    var classes = ['container', 'mx-auto', className];
    return react_1.default.createElement("div", { className: classnames_1.default.apply(void 0, classes) }, children);
};
exports.default = Container;
//# sourceMappingURL=index.js.map